import React, { ReactElement } from 'react';

import { SerializedStyles } from '@emotion/react';

import ConfirmModalComponent from '@components/common/ConfirmModal/ConfirmModal';

import usePortal from './usePortal';

interface UseConfirmModalPropsType {
  textLineList?: string[];
  handleConfirmButton?: () => void;
  handleCancelButton?: () => void;
  children?: ReactElement;
  isShowCancelButton?: boolean;
  isShowConfirmButton?: boolean;
  style?: SerializedStyles;
  cancelButtonText?: string;
  confirmButtonText?: string;
}

export default function useConfirmModal() {
  const { PopUp, onShowPopUp, onHidePopUp } = usePortal('dim');

  const ConfirmModal = ({
    textLineList,
    children,
    handleConfirmButton = () => {},
    handleCancelButton = () => {},
    isShowCancelButton = true,
    isShowConfirmButton = true,
    style,
    cancelButtonText = '취소',
    confirmButtonText = '확인',
  }: UseConfirmModalPropsType): ReactElement => (
    <PopUp>
      <ConfirmModalComponent
        textLineList={textLineList}
        onHide={() => {
          handleCancelButton();
          onHidePopUp();
        }}
        onClick={async () => {
          await handleConfirmButton();
          onHidePopUp();
        }}
        isShowCancelButton={isShowCancelButton}
        isShowConfirmButton={isShowConfirmButton}
        style={style}
        cancelButtonText={cancelButtonText}
        confirmButtonText={confirmButtonText}
      >
        {children}
      </ConfirmModalComponent>
    </PopUp>
  );

  return { ConfirmModal, onShowConfirmModal: onShowPopUp };
}
